import React from "react";
import _ from "lodash";
import { Col, Row, Button, Form, Divider, Typography, Tooltip } from "antd";
import { Redirect } from "react-router-dom";
import { checkAuthenticity, getCsrfToken, getLoginProviders, signIn } from "utils/authService";
import AppLoader from "components/AppLoader";
import ProductLogo from "components/widgets/ProductLogo";
import { emailValidator, generateFormFields, FieldTypes } from "utils/formUtils";
import UserAPI from "restAPI/UserAPI";
import TotpAPI from "restAPI/TotpAPI";
import { getCurrentYear } from "utils/dateUtils";
import { clearTemporarySessionStorage } from 'utils/sessionFilterStoreUtil';
import { getLocalStorage, setLocalStorage } from "utils/localStorageUtils";
import message from "components/CustomMessage";
import ImageWithFallback from "components/widgets/ImageWithFallback";
import moment from "moment";
import { Input, Space } from "antd-v5";
import axios from "axios";
import GlobalSettingAPI from "restAPI/GlobalSettingAPI";

const GOOGLE = "GOOGLE";
const AZURE = "AZURE";
const SSO = "SSO";
export const BASIC_AUTH = "BASIC_AUTH";
//fetch updated image, witout date query param, browser requires cache clearing
const currentDateToImgUrl = moment().startOf('minute');
const BANNER_URL = `${window.location.origin}/static-content/ArmorCode_platform-banner.png?date=${currentDateToImgUrl.format('YYYY-MM-DDTHH:mm')}`;

const BANNER_IMG_FALLBACK_SRC = "/images/ArmorCode_platform-banner.png";

// const Login = withRouter(
    class Login extends React.Component{
        constructor(props){
            super(props);
            const params = new URLSearchParams(this.props.location?.search || "");
            this.formRef = React.createRef();
            this.inputRef = React.createRef();
            this.state = {
                isAuthentic: null,
                userData: null,
                oktaLoginScreen: false,
                showWorkEmail: false,
                loginLoading: false,
                error: params.has("error") ? "Something went wrong. Please try again!" : "",
                message: params.get("message") || undefined,
                loginProviders: undefined,
                hasZendesk: params.get("source"),
                mfaRequired: false,
                verifyingOTP: false,
            }
        }

        async componentDidMount() {
            const email = getLocalStorage("email");
            if(!_.isEmpty(email)){
                await this.getLoginProviders(email);
                this.checkAuthenticity();
                if(!_.isEmpty(this.state.error)){
                    this.props.history.replace('/login');
                }
            } else {
                this.setState({showWorkEmail: true})
            }
        }

        componentDidUpdate(){
            const {error, message: _message} = this.state;
            if(error || _message){
                this.closeError = message.error(error || _message, 0, "login-error");
            }
        }

        componentWillUnmount() {
            if (this.closeError) {
                this.closeError();
            }
        }

        async getLoginProviders(email) {
            return new Promise((resolve, reject) => {
                getLoginProviders({email}).then((providers) => {
                    this.setState({
                        loginProviders: providers.data || []
                    }, () => resolve());
                }).catch((error) => {
                    reject(error);
                });
            });
        }

        async checkAuthenticity() {
            const params = new URLSearchParams(this.props.location?.search || "");
            let isAuthentic = false, userData = null;
            const {hasZendesk} = this.state;
            try {
                const { loginProviders } = this.state;
                const showCredentialFields = _.includes(loginProviders, BASIC_AUTH);
                let data;
                if (showCredentialFields) {
                    // check otp status, incase user has refreshed page midway      
                    data = await axios.get('/api/totp/status', {
                        headers: {
                            'x-csrf-token': getCsrfToken()
                        }
                    });
                }
                if (data?.data && data.data.enabled && !data.data.totpVerified) {
                    localStorage.setItem("CSRF", data.headers['x-csrf-token']);
                    this.setState({mfaRequired: true});
                } else {
                    userData = await checkAuthenticity();
                    isAuthentic = true;
                    if(hasZendesk){
                        window.open(`${window.location.origin}/api/jwt/zendesk/sso`, '_self', 'noopener noreferrer')
                    }
                }
            } catch (e) {
                console.error(e);
                const errorCode = _.result(e, "response.data.error");
                if (errorCode) message.error(_.result(e, "response.data.message"));
                if (hasZendesk) {
                  if (params.has("target")) {
                    setLocalStorage("source", "zendesk");
                  }
                  else{
                    return window.open(
                        `${window.location.origin}/public/zendeskssologin`,
                        "_self"
                    );
                  }
                } else {
                  localStorage.removeItem("source");
                }
            } finally {
                this.setState({ isAuthentic, userData });
                if(!isAuthentic){
                    clearTemporarySessionStorage();
                }
                // if (!_.isUndefined(this.state.message)) {
                //     message.error(this.state.message);
                // }
            }
        }
        simplifyLoginWithOkta = async () => {
            const email = getLocalStorage("email");
            if(!_.isEmpty(email)){
                try {
                    const res = await UserAPI.oktaLogin(email);
                    window.location.href = res
                } catch (e) {
                    this.setState({error: _.result(e, "response.data", _.result(e, "message"))})
                    console.error(e);
                }
            }
            else {
                this.setState({oktaLoginScreen: true})
            }
        }
        loginWithOkta = async (data) => {
            if(data.email){
                this.setState({loginLoading: true});
                try {
                    const res = await UserAPI.oktaLogin(data.email);
                    window.location.href = res
                } catch (e) {
                    this.setState({error: _.result(e, "response.data", _.result(e, "message"))})
                    console.error(e);
                } finally {
                    this.setState({loginLoading: false});
                }
            }
        }
        credentialSubmit = async (data) => {
            this.setState({loginLoading: true});
            try {
                this.email = data.email;
                setLocalStorage("email", data.email);
                const loginData = await signIn(data);
                const { loginProviders } = this.state;
                const showCredentialFields = _.includes(loginProviders, BASIC_AUTH);
                if (showCredentialFields) {
                    localStorage.setItem("CSRF", loginData.headers['x-csrf-token']);
                    const totpConfigEnabled = await GlobalSettingAPI.getTOTPConfig().promise;
                    if (totpConfigEnabled) {
                        // Check TOTP status
                        const resp = await TotpAPI.getTOTPStatus().promise;
    
                        if (resp?.data?.enrollmentRequired) { // TOTP not enabled, redirect to enroll
                            this.props.history.replace('/login/totp-enroll');
                            return;
                        } else if (!resp?.data?.enrollmentRequired && resp?.data?.enabled) { // TOTP enabled
                            this.setState({ mfaRequired: true });
                            this.inputRef.current?.focus();
                            return;
                        }
                    }
                    // for existing users, MFA not mandatory
                }
                this.props.history.replace('/');
            } catch (err) {
                this.setState({error: _.result(err, "response.data", _.result(err, "message"))})
                console.error(err);
            } finally {
                this.setState({loginLoading: false})
            }
        }

        onWorkEmailSubmit = async (data) => {
            setLocalStorage("email", data.email);
            await this.getLoginProviders(data.email);
            this.checkAuthenticity();
            if(!_.isEmpty(this.state.error)){
                this.props.history.replace('/login');
            }
            this.setState({showWorkEmail: false});
        }

        otpSubmit = async (values) => {
            this.setState({ verifyingOTP: true });
            try {
                const resp = await TotpAPI.verifyLoginTOTP({
                    verificationCode: +values.code,
                    email: this.email || getLocalStorage('email')
                }).promise;
                if (resp?.body?.success) {
                    message.success(resp.body.data);
                    this.props.history.replace('/');
                } else {
                    message.error("OTP Verification failed. Please check the code and try again.");
                }
            } catch (e) {
                message.error(e?.response?.data?.body?.message || e?.response?.data?.message || e?.response?.message || e?.message || "OTP Verification failed. Please try again.");
            } finally {
                this.setState({ verifyingOTP: false });
            }
        }

        render(){
            const { isAuthentic, oktaLoginScreen, loginLoading , showWorkEmail, loginProviders, mfaRequired, verifyingOTP } = this.state;
            const showCredentialFields = _.includes(loginProviders, BASIC_AUTH);
            const email = getLocalStorage("email", "");
            if(!_.isEmpty(email) && isAuthentic === null){
                return <AppLoader />;
            }
            if (isAuthentic) {
                return <Redirect to="/"/>;
            }
            const theme = document.documentElement.getAttribute("data-theme");
            const isLightTheme = theme !== 'dark';

            return (
                <Row className="login-page-v2">
                    <Col span={8} className="left-section">
                        <div>
                            <ProductLogo dark={isLightTheme} height={40} />
                        </div>
                        <div className="login-box">
                            {mfaRequired ? 
                                <div className="otp-wrapper">
                                    <div className="otp-wrapper-heading">Multi-Factor Authentication</div>
                                    <Form layout="vertical" size="large" onFinish={this.otpSubmit} initialValues={{ email }}>
                                        <div className="login-otp-form">
                                            <Form.Item
                                              label="Enter 6-digit verification code "
                                              name="code"
                                              rules={[{ required: true, message: "Please enter the code" }, { len: 6, message: "Code must be 6 digits" }]}
                                            >
                                              <Input.OTP ref={this.inputRef} length={6} inputMode="numeric" />
                                            </Form.Item>
                                        </div>
                                        <Row className="justify-content-center p-t-l">
                                            <Space size={25}>
                                                <Button type="default" disabled={verifyingOTP} onClick={() => window.location.hash = "#/logout"}>
                                                  Cancel
                                                </Button>
                                                <Button type="primary" htmlType="submit" loading={verifyingOTP}>
                                                  Sign In
                                                </Button>
                                            </Space>
                                        </Row>
                                    </Form>
                                </div>
                            : 
                            <>
                            {
                                
                                showWorkEmail 
                                ? 
                                <div className="login-box">
                                    <Typography.Title level={3} className="login-text">Welcome</Typography.Title> 
                                    <Form layout="vertical" size="large" onFinish={this.onWorkEmailSubmit}>
                                        {generateFormFields(workEmailfield)}
                                        <Button className="w-100 login-btn" type="primary" loading={loginLoading} htmlType="submit">
                                            Continue
                                        </Button>
                                    </Form>
                                </div>
                                :
                                 _.isEmpty(loginProviders)
                                ?
                                <Typography.Title level={3}>We will be right back!</Typography.Title>
                                :
                                <>
                                    <Typography.Title level={3} className="login-text">Login</Typography.Title>
                                    <Typography.Paragraph className="login-text login-text-secondary">Welcome! Please sign in to continue</Typography.Paragraph>
                                </>
                            }
                            {oktaLoginScreen && !showWorkEmail ?
                                <div className="p-t-m">
                                 <Form ref={this.formRef} layout="vertical" onFinish={this.loginWithOkta} initialValues={{ email }}>
                                     {generateFormFields(fields)}

                                     <Form.Item>
                                         <Button className="m-r-sm" onClick={() => this.setState({oktaLoginScreen: !oktaLoginScreen})}>
                                             Back
                                         </Button>
                                         <Button type="primary" loading={loginLoading} htmlType="submit">
                                             Login
                                         </Button>
                                     </Form.Item>
                                 </Form>
                                </div>
                                :
                                <>
                                {loginProviders?.includes(GOOGLE) && <div>
                                    <Button disabled={loginLoading} href="/oauth2/authorization/google" block size="large" className="login-btn login-provider-btn">
                                        <img alt="Google" src="/images/google.svg" width={15} className="m-r-sm" />
                                        Sign in using Google
                                    </Button>
                                </div>}
                                {loginProviders?.includes(AZURE) && <div className="p-t-m">
                                    <Button disabled={loginLoading} href="/oauth2/authorization/azure" block size="large" className="login-btn login-provider-btn">
                                        <img alt="Microsoft" src="/images/microsoft.svg" width={15} className="m-r-sm" />
                                        Sign in using Microsoft
                                    </Button>
                                </div>}
                                {loginProviders?.includes(SSO) && <div className="p-t-m">
                                    <Tooltip title={SSOHelpText}>
                                        <Button disabled={loginLoading} onClick={this.simplifyLoginWithOkta} block size="large" className=" login-btn login-provider-btn">
                                            <img alt="SSO" src="/images/login_key.svg" width={12} className="m-r-sm" />
                                            Sign in using SSO
                                        </Button>
                                    </Tooltip>
                                </div>}
                                { showCredentialFields && (
                                    <>
                                        <Divider className="m-b-0">OR</Divider>
                                        <div>
                                            <Form layout="vertical" size="large" onFinish={this.credentialSubmit} initialValues={{ email }}>
                                                {generateFormFields(userFields)}
                                                <Button className="w-100 m-t-sm login-btn" type="primary" loading={loginLoading} htmlType="submit">
                                                    Sign In
                                                </Button>
                                            </Form>
                                        </div>
                                    </>
                                )}
                                {/* <div className={!showCredentialFields ? 'p-t-m' : ''}></div> */}
                                </>
                               
                            }
                            </>}
                        </div>
                        <div className="login-footer-text">
                           <Typography.Paragraph> {getCurrentYear()} ArmorCode Inc, All rights reserved</Typography.Paragraph>
                        </div>
                    </Col>
                    <Col span={16} className="right-section">
                        <div className="section-wrapper" style={{textAlign: "center"}}>
                            <a href="public/login-banner-link"rel="noopener noreferrer" target="_blank"> 
                                <ImageWithFallback src={BANNER_URL} fallbackSrc={BANNER_IMG_FALLBACK_SRC} alt="ArmorCode - unify application security and vunerability management"  fallbackExtensions={["png"]} className="banner"/>
                            </a>
                        </div>
                    </Col>
                </Row>
            )
        }
    }
// )

export default Login;

const userFields = [
    {
        name: "email",
        label: "Email",
        colSpan: 24,
        required: true,
        style: {margin: 'auto'},
        className:"user-login-fields",
        rules: [emailValidator]
    },
    {
        name: "password",
        label: "Password",
        type: FieldTypes.PASSWORD,
        colSpan: 24,
        required: true,
        style: {margin: 'auto'},
        className:"user-login-fields",
    }
]

const fields = [
    {
        name: "email",
        label: "Your work email",
        type: "email",
        colSpan: 20,
        style: {margin: 'auto'},
        required: true,
        rules: [emailValidator],
        props: {
            autoFocus: true
        }
    }
];

const workEmailfield = [
    {
        name: "email",
        label: "Work Email",
        placeholder: "Enter your work email",
        type: "email",
        colSpan: 24,
        style: {margin: 'auto'},
        required: true,
        rules: [emailValidator],
        props: {
            autoFocus: true
        }
    }
];

export const SSOHelpText = "We support multiple providers: OKTA, PingIdentity, Microsoft-SAML"